import React from "react";

const CHUNK_RELOAD_KEY = "jaldi_chunk_reload_attempted";
const CHUNK_RELOAD_RESET_DELAY = 10000;

export const isChunkLoadError = (error) => {
  const message = `${error?.name || ""} ${error?.message || error || ""}`;
  return /ChunkLoadError|Loading chunk|Failed to fetch dynamically imported module|Importing a module script failed/i.test(
    message
  );
};

class ChunkLoadErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
    this.resetTimer = null;
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidMount() {
    this.resetTimer = window.setTimeout(() => {
      try {
        window.sessionStorage.removeItem(CHUNK_RELOAD_KEY);
      } catch (_error) {
        // Storage may be unavailable in privacy-restricted browsers.
      }
    }, CHUNK_RELOAD_RESET_DELAY);
  }

  componentDidCatch(error) {
    if (!isChunkLoadError(error)) return;

    try {
      if (window.sessionStorage.getItem(CHUNK_RELOAD_KEY)) return;
      window.sessionStorage.setItem(CHUNK_RELOAD_KEY, "true");
    } catch (_error) {
      // Without the retry marker, an automatic reload could loop forever.
      return;
    }

    this.reloadPage();
  }

  componentWillUnmount() {
    if (this.resetTimer) window.clearTimeout(this.resetTimer);
  }

  reloadPage = () => {
    const reloadPage = this.props.reloadPage || (() => window.location.reload());
    reloadPage();
  };

  handleManualReload = () => {
    try {
      window.sessionStorage.removeItem(CHUNK_RELOAD_KEY);
    } catch (_error) {
      // Continue with the manual reload.
    }
    this.reloadPage();
  };

  render() {
    if (!this.state.error) return this.props.children;

    return (
      <main role="alert" style={{ padding: "48px 24px", textAlign: "center" }}>
        <h1>We have updated this page</h1>
        <p>Please reload once to open the latest version.</p>
        <button type="button" onClick={this.handleManualReload}>
          Reload page
        </button>
      </main>
    );
  }
}

export default ChunkLoadErrorBoundary;
